import { render, staticRenderFns } from "./OtherIncomeExpense.vue?vue&type=template&id=703913f2&"
import script from "./OtherIncomeExpense.vue?vue&type=script&lang=js&"
export * from "./OtherIncomeExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports